import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { SMSSenderLayout } from "../SMSSenderLayout";
import { SMSSenderProps } from "../SMSSenderProps";

interface HomePageProps extends NSARouterMakerResult, SMSSenderProps { }

export default function HomePage(props: HomePageProps)
{
	return (
		<SMSSenderLayout
			{...props}
		>
			<NSAHomePage
				{...props}
			/>
		</SMSSenderLayout>
	);
}